export const ProductionPlan = (json: IProductionPlan): IProductionPlanModel => {
	const {
		date,
		count_meals,
		in_production_meals_sum,
		in_production_unique_meals_sum,
		gate_closing_date,
		gate_closed,
		ordered_meals_sum,
		ordered_unique_meals_sum,
		count_orders,
		count_unique_meals,
		is_final,
		completed_at,
		created_at,
		updated_at,
		final_simulation_id,
		...rest
	} = json

	return {
		...rest,
		date: new Date(date),
		isFinal: is_final,
		countMeals: count_meals,
		countOrders: count_orders,
		countUniqueMeals: count_unique_meals,
		inProductionMealsSum: in_production_meals_sum || 0,
		inProductionUniqueMealsSum: in_production_unique_meals_sum,
		gateClosingDate: gate_closing_date,
		gateClosed: gate_closed,
		orderedMealsSum: ordered_meals_sum,
		orderedUniqueMealsSum: ordered_unique_meals_sum,
		completedAt: completed_at ? new Date(completed_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
		finalSimulationID: final_simulation_id,
	}
}

export const ProductionPlanOrderedMeal = (json: IProductionPlanOrderedMeal): IProductionPlanOrderedMealModel => {
	const {
		production_plan_id,
		meal_id,
		variant_id,
		size_id,
		size_name,
		meal_kind,
		meal_type,
		meal_category,
		thumb_url,
		name,
		client_name,
		created_at,
		updated_at,
		...rest
	} = json

	return {
		...rest,
		productionPlanId: production_plan_id,
		mealId: meal_id,
		variantId: variant_id,
		sizeId: size_id,
		sizeName: size_name,
		mealKind: meal_kind,
		mealType: meal_type,
		name,
		clientName: client_name,
		mealCategory: meal_category,
		thumbUrl: thumb_url,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

export const ProductionPlanDetailsMeal = (json: IProductionOrderDetailsMeal): IProductionOrderDetailsMealModel => {
	const {
		created_at,
		updated_at,
		addon_category,
		meal_category,
		meal_id,
		variant_id,
		size_id,
		size_name,
		meal_kind,
		meal_type,
		thumb_url,
		overproduction,
		sales_quantity,
		sales_in_fridge,
		detected_changes,
		weight_issues,
		...rest
	} = json

	return {
		...rest,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		addonCategory: addon_category ?? null,
		mealCategory: meal_category ?? null,
		mealId: meal_id,
		variantId: variant_id,
		sizeId: size_id,
		sizeName: size_name,
		mealKind: meal_kind,
		mealType: meal_type,
		thumbUrl: thumb_url ?? null,
		overproduction,
		salesQuantity: sales_quantity,
		salesInFridge: sales_in_fridge,
		detectedChanges: detected_changes ?? null,
		weightIssues: weight_issues ?? null,
	}
}

export const ProductionPlanDetails = (json: IProductionPlanDetails): IProductionPlanDetailsModel => {
	const {
		date,
		count_meals,
		count_orders,
		count_unique_meals,
		is_final,
		meals,
		completed_at,
		created_at,
		updated_at,
		final_simulation_id,
		name,
		production_duration,
		production_start_date,
		production_end_date,
		count_meals_overproduction,
		gate_closing_date,
		gate_closed,
		in_production_meals_sum,
		in_production_unique_meals_sum,
		ordered_meals_sum,
		ordered_unique_meals_sum,
		order_stats_synced_at,
		...rest
	} = json

	return {
		...rest,
		date: new Date(date),
		isFinal: is_final,
		countMeals: count_meals,
		countOrders: count_orders,
		countUniqueMeals: count_unique_meals,
		inProductionMealsSum: in_production_meals_sum || 0,
		inProductionUniqueMealsSum: in_production_unique_meals_sum,
		orderedMealsSum: ordered_meals_sum,
		orderedUniqueMealsSum: ordered_unique_meals_sum,
		meals: meals ? meals.map(m => ProductionPlanDetailsMeal(m)) : [],
		completedAt: completed_at ? new Date(completed_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
		finalSimulationID: final_simulation_id,
		gateClosingDate: gate_closing_date,
		gateClosed: gate_closed,
		name,
		productionDuration: production_duration,
		productionStartDate: production_start_date ? new Date(production_start_date) : null,
		productionEndDate: production_end_date ? new Date(production_end_date) : null,
		countMealsOverproduction: count_meals_overproduction,
		orderStatsSyncedAt: order_stats_synced_at ? new Date(order_stats_synced_at) : null,
	}
}
